import { headerBorderColor } from 'globals/colors';

import { iconClose } from 'globals/assets';

export default {
  wrapper: {
    width: '100%',
    fontWeight: '300',
    fontSize: '12px',
    position: 'relative',
    display: 'flex',
    borderBottom: `1px solid ${headerBorderColor}`,
    borderRadius: '9px 9px 0 0',
    flex: '0 0 auto',
    height: '195px',
    alignItems: 'center',
  },
  close: {
    wrapper: {
      position: 'absolute',
      top: '18px',
      right: '10px',
      padding: '5px',
      borderRadius: '50%',
      cursor: 'pointer',
    },
    icon: {
      backgroundImage: `url("${iconClose}")`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '16px',
      height: '16px',
      width: '16px',
    },
  },
};
